import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import CodexVersionDisplayBar from 'components/CodexVersionDisplayBar';
import DynamicSwitchBox from 'components/DynamicSwitchGroup/DynamicSwitchBox';

import '../UpdatedDynamicSwitchGroupDetails.css';
import { getDynamicSwitchGroupDiff } from './UpdatedDynamicSwitchGroupDetails.actions';

const UpdatedDynamicSwitchGroupDetails = () => {
  const dispatch = useDispatch();
  const { dynamicSwitchGroup } = useParams();

  const codexVersionId = useSelector((state) =>
    state.codexVersion ? state.codexVersion.codexVersionId : null
  );

  useEffect(() => {
    if (codexVersionId && dynamicSwitchGroup) {
      dispatch(getDynamicSwitchGroupDiff(codexVersionId, dynamicSwitchGroup));
    }
  }, [dispatch, codexVersionId, dynamicSwitchGroup]);

    return (
      <Container fluid>
        <CodexVersionDisplayBar />
        <Row>
          <Col xs={12}>
            <DynamicSwitchBox />
          </Col>
        </Row>
      </Container>
    );
};

export default UpdatedDynamicSwitchGroupDetails;

